export const HCatchServerError = (response: any) => {
  if (response?.errors) {
    return Object.keys(response.errors).map((key) => {
      return response.errors[key].join("\n");
    });
  }

  if (response?.message) {
    return response.message;
  }

  if (response?.data?.data?.message) {
    return response?.data?.data?.message;
  }

  if (response?.data?.data?.error) {
    return response?.data?.data?.error;
  }

  if (response?.data) {
    if (response.data.message === "Page not found") {
      return "Url no Valida o paramentos no validos";
    }
  }

  if (response?.data) {
    if (response.data.message === "This action is unauthorized.") {
      return "Esta acción no está autorizada";
    }
  }

  if (response?.data?.errors) {
    const { errors } = response.data;
    let message = "";
    for (const property in errors) {
      message += `${errors[property]}\n`;
    }
    return message;
  }

  if (response?.data?.message) {
    return response?.data.message;
  }

  return "Ups ha ocurrido un inconveniente";
};
